document.addEventListener('DOMContentLoaded', function () {
  const sizeguideButton = document.querySelector('.sizeguide-button');
  const popupOverlay = document.getElementById('sizeguide-popup');
  const closePopupButton = document.querySelector('.close-popup');
  const sizeguideContent = document.getElementById('sizeguide-content');

  // URL der Seite, deren Inhalt im Popup angezeigt werden soll
  const sizeguidePageUrl = '/pages/returns'; // Passe die URL entsprechend an

  // Funktion zum Laden des Seiteninhalts
  function loadSizeguideContent() {
    fetch(sizeguidePageUrl)
      .then(response => response.text())
      .then(html => {
        // Extrahiere den Inhalt der Seite
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const pageContent = doc.querySelector('.page-content'); // Passe den Selektor an

        if (pageContent) {
          sizeguideContent.innerHTML = pageContent.innerHTML;
        } else {
          sizeguideContent.innerHTML = '<p>Inhalt nicht gefunden.</p>';
        }
      })
      .catch(error => {
        console.error('Fehler beim Laden des Inhalts:', error);
        sizeguideContent.innerHTML = '<p>Fehler beim Laden des Inhalts.</p>';
      });
  }

  sizeguideButton.addEventListener('click', function () {
    loadSizeguideContent();
    popupOverlay.style.display = 'block';
  });

  closePopupButton.addEventListener('click', function () {
    popupOverlay.style.display = 'none';
  });

  // Schließt das Popup, wenn außerhalb des Popup-Inhalts geklickt wird
  window.addEventListener('click', function (event) {
    if (event.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });
});

